import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import NavigationDrawer from "../../../components/NavigationDrawer";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import AllPlans from "./AllPlans";
import Invoices from "./Invoices";

const tabs = [
  { label: "invoices", value: "invoice" },
  { label: "allSubscriptions", value: "subscription" },
];

function AdminSubscription() {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.activeTab.tabs);

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, subscription: tab }));
  };

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading="plans"
            tabs={tabs}
            activeTab={activeTab.subscription}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.subscription === "invoice" ? (
            <Invoices />
          ) : activeTab.subscription === "subscription" ? (
            <AllPlans />
          ) : null}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default AdminSubscription;
